import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const ModalContentWrapper = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 336px 496px;
	grid-template-rows: 465px;
	${media.tablet} {
		grid-template-columns: 230px 450px;
		grid-template-rows: 360px;
	}
	${media.mobile} {
		grid-template-columns: 100%;
		grid-template-rows: 372px;
	}
`;

export const ModalPhoto = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	${media.mobile} {
		display: none;
	}
`;

export const ModalInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;
	height: 100%;
	padding: 48px 69px 50px 48px;
	${media.tablet} {
		padding: 40px;
	}
	${media.mobile} {
		padding: 16px;
	}
`;

export const AlignTextStyles = css`
	${media.mobile} {
		display: block;
		text-align: center;
		color: var(--text-primary) !important;
	}
`;

export const PhoneStyles = css`
	display: block;
	margin-block: 13px;
	${media.tablet} {
		font-weight: 500;
		font-size: 22px;
		line-height: 28px;
		margin-block: 8px 16px;
	}
	${media.mobile} {
		width: 100%;
		max-width: 100%;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		color: #fff;
		background-color: var(--control-primary);
		border-radius: 4px;
		margin-block: 32px 15px;
		padding-block: 12px;
	}
`;

export const DescriptionTextStyle = css`
	margin-top: 16px;
`;
